'use client';
import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import { MONTHLY_STATS } from './mockOwnerData';

interface TooltipPayload {
  name: string;
  value: number;
  color: string;
}

interface CustomTooltipProps {
  active?: boolean;
  payload?: TooltipPayload[];
  label?: string;
}

function CustomTooltip({ active, payload, label }: CustomTooltipProps) {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white border border-gray-100 rounded-xl shadow-card-hover p-3 text-sm">
      <p className="font-600 text-gray-800 mb-2">{label}</p>
      {payload.map(item => (
        <div key={`tooltip-${item.name}`} className="flex items-center gap-2 text-xs">
          <span className="w-2 h-2 rounded-full" style={{ background: item.color }} />
          <span className="text-gray-600">{item.name}:</span>
          <span className="font-700 text-gray-900 tabular-nums">{item.value}</span>
        </div>
      ))}
    </div>
  );
}

export default function OwnerChart() {
  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-card p-5">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="font-600 text-gray-900">المشاهدات وطلبات التواصل</h3>
          <p className="text-xs text-gray-400 mt-0.5">آخر 7 أشهر</p>
        </div>
        <span className="text-xs text-gray-400 bg-gray-50 px-3 py-1 rounded-full border border-gray-100">أكتوبر 2025 — أبريل 2026</span>
      </div>
      <ResponsiveContainer width="100%" height={240}>
        <BarChart data={MONTHLY_STATS} barGap={4}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
          <XAxis dataKey="month" tick={{ fontSize: 12, fill: '#94a3b8' }} axisLine={false} tickLine={false} />
          <YAxis tick={{ fontSize: 12, fill: '#94a3b8' }} axisLine={false} tickLine={false} />
          <Tooltip content={<CustomTooltip />} />
          <Legend wrapperStyle={{ fontSize: '12px', paddingTop: '12px' }} />
          <Bar dataKey="views" name="المشاهدات" fill="hsl(199 89% 48%)" radius={[4, 4, 0, 0]} />
          <Bar dataKey="unlocks" name="طلبات التواصل" fill="hsl(38 92% 50%)" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}